/**
 * @generated SignedSource<<bcf57040b077702aba5ba53aba40b48a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RoadmapsContent$data = {
  readonly jira: {
    readonly roadmapFavourites: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly RoadmapItem_collection?: {
            readonly " $fragmentSpreads": FragmentRefs<"RoadmapItem_collection">;
          } | null;
          readonly collectionId?: AGG$Long | null;
          readonly id?: string;
          readonly title?: string | null;
        };
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    };
    readonly roadmapRecents: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly RoadmapItem_collection?: {
            readonly " $fragmentSpreads": FragmentRefs<"RoadmapItem_collection">;
          } | null;
          readonly collectionId?: AGG$Long | null;
          readonly id?: string;
          readonly title?: string | null;
        };
      } | null> | null;
    };
  };
  readonly " $fragmentType": "RoadmapsContent";
};
export type RoadmapsContent$key = {
  readonly " $data"?: RoadmapsContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoadmapsContent">;
};

import Nav4RoadmapsContentQuery_graphql from './Nav4RoadmapsContentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = [
  {
    "kind": "RequiredField",
    "field": {
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "kind": "ScalarField",
                "name": "id"
              },
              "action": "THROW"
            },
            {
              "kind": "ScalarField",
              "name": "collectionId"
            },
            {
              "kind": "ScalarField",
              "name": "title"
            },
            {
              "fragment": {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "RoadmapItem_collection"
                  }
                ],
                "type": "JiraProductDiscoveryCollection"
              },
              "kind": "AliasedInlineFragmentSpread",
              "name": "RoadmapItem_collection"
            }
          ],
          "type": "JiraProductDiscoveryCollection"
        }
      ]
    },
    "action": "THROW"
  }
],
v2 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentURL"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": Nav4RoadmapsContentQuery_graphql
    }
  },
  "name": "RoadmapsContent",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "roadmapFavourites",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "filter",
                  "value": {
                    "sort": {
                      "order": "DESC"
                    },
                    "type": "JPD_COLLECTION"
                  }
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 15
                }
              ],
              "concreteType": "JiraFavouriteConnection",
              "kind": "LinkedField",
              "name": "favourites",
              "plural": false,
              "selections": [
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "hasNextPage"
                    }
                  ]
                },
                {
                  "concreteType": "JiraFavouriteEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": (v1/*: any*/)
                },
                (v2/*: any*/)
              ]
            },
            "action": "THROW"
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": "roadmapRecents",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "currentURL",
                  "variableName": "currentURL"
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 20
                },
                {
                  "kind": "Literal",
                  "name": "types",
                  "value": [
                    "JPD_COLLECTION"
                  ]
                }
              ],
              "concreteType": "JiraSearchableEntityConnection",
              "kind": "LinkedField",
              "name": "recentItems",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraSearchableEntityEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": (v1/*: any*/)
                },
                (v2/*: any*/)
              ]
            },
            "action": "THROW"
          }
        ]
      },
      "action": "THROW"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "cb31d658bc1e59d98b259d4e0c2d9daf";

export default node;
